export default "__VITE_ASSET__9d63cf9f__"